import { api } from 'services/companiesApi';

export const getQuestionnairesOverall = (campaignId: string) => {
	return api.get(`/campaigns/${campaignId}/questionnaires-overall`);
};
